<template>
    <div class="icon">
        <div v-if="inventory=='1595_Brussels'">
           <div class="year">
               1595
           </div>
           <div class="name">
               Brussels
           </div>
       </div>
       <div v-if="inventory=='1615_Brussels'">
           <div class="year">
               1615
           </div>
           <div class="name">
               Brussels
           </div>
       </div>
        <div v-if="inventory=='1619_Innsbruck'">
           <div class="year">
               1619
           </div>
           <div class="name" style=" font-size:12px;">
              Innsbruck
           </div>
       </div>
       <div v-if="inventory=='1610_19_Vienna'">
           <div class="year" style="position:relative;top:-5px;left:-2px;color:#2e2e2e">
               1610
           </div>
           <div class="year2">
               1619
           </div>
           <div class="name" style="position:relative;top:-17px;">
               Vienna
           </div>
       </div>
       <div v-if="inventory=='1619_Vienna'">
           <div class="year">
               1619
           </div>
           <div class="name">
               Vienna
           </div>
       </div>
       <div v-if="inventory=='1623_Briers_A'">
           <div class="letter">
               <div class="letter-in">A</div>
           </div>
           <div class="year">
               1623
           </div>
           <div class="name">
               Briers
           </div>
           
       </div>
       <div v-if="inventory=='1623_Briers_B'">
            <div class="letter">
               <div class="letter-in">B</div>
           </div>
           <div class="year">
               1623
           </div>
           <div class="name">
               Briers
           </div>
       </div>
       <div v-if="inventory=='1621_Prague_A'">
            <div class="letter">
               <div class="letter-in">A</div>
           </div>
           <div class="year">
               1621
           </div>
           <div class="name">
               Prague
           </div>
       </div>
       <div v-if="inventory=='1621_Prague_AA'">
            <div class="letter">
               <div class="letter-in" style="letter-spacing: -35px">AA</div>
           </div>
           <div class="year">
               1621
           </div>
           <div class="name">
               Prague
           </div>
       </div>
       <div v-if="inventory=='1621_Prague_B'">
            <div class="letter">
               <div class="letter-in">B</div>
           </div>
           <div class="year">
               1621
           </div>
           <div class="name">
              Prague
           </div>
       </div>
       <div v-if="inventory=='1635_Prague'">
           <div class="year">
               1635
           </div>
           <div class="name">
              Prague
           </div>
       </div>
       <div v-if="inventory=='1648_Prague'">
           <div class="year">
               1648
           </div>
           <div class="name">
               Prague
           </div>
       </div>
       <div v-if="inventory=='1652_Stockholm'">
           <div class="year">
               1652
           </div>
           <div class="name"  style=" font-size:12px;">
              Stockholm
           </div>
       </div>
       <div v-if="inventory=='2020_Prague'">
           <div class="year">
               2020
           </div>
           <div class="name">
               Prague
           </div>
       </div>
   </div>
</template>

<script>
    export default {
        props: ['inventory'],
        data() {
            return {

            }
        },

        methods: {

        },

        mounted() {

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .italic {
        font-style: italic;
    }

    .icon {
        width: 70px;
        height: 70px;
        background-image: url("/static/icon-background.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        font-family:Garamond, Georgia, serif;
        overflow:hidden;
        border-radius:3px;

    }
    .year{
        position:relative;
        padding-top:15px;
        font-size:25px;
        text-align:center;
    }
    .year2{
        position:relative;
        top:-12px;
        right:-4px;
        font-size:25px;
        text-align:center;
    }
    .name{
         position:relative;
        padding-top:5px;
        font-size:15px;
        text-align:center;
    }
    .letter{
        position:absolute;
        font-size:65px;
        top:6px;
        left:6px;
        width:58px;
        height:58px;
        color:#828282;
        overflow:hidden;
    }
    .letter-in{
        position:relative;
        top:20px;
        left:25px;
    }
</style>



// WEBPACK FOOTER //
// src/components/TheInventoryIcon.vue